import { getConnection } from '@devprotocol/elements';

const CONNECTION_ID = '__clubs_connection_id__';

const connection = (id = CONNECTION_ID) => getConnection(id);

export { CONNECTION_ID, connection };
